/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import "../../core/has.js";
import { isNone as e } from "../../core/maybe.js";

function n(e, n) {
  if (e === n) return !0;
  if (null == e || null == n) return !1;
  if (e.length !== n.length) return !1;

  for (var _t = 0; _t < e.length; _t++) {
    var _r = e[_t],
        _a = n[_t];
    if (_r.length !== _a.length) return !1;

    for (var _e = 0; _e < _r.length; _e++) {
      if (_r[_e] !== _a[_e]) return !1;
    }
  }

  return !0;
}

function t(e, t) {
  if (e === t) return !0;
  if (null == e || null == t) return !1;
  if (e.length !== t.length) return !1;

  for (var _r2 = 0; _r2 < e.length; _r2++) {
    if (!n(e[_r2], t[_r2])) return !1;
  }

  return !0;
}

function r(e, n) {
  return !!f(e.spatialReference, n.spatialReference) && e.x === n.x && e.y === n.y && e.z === n.z && e.m === n.m;
}

function a(e, n) {
  return e.hasZ === n.hasZ && e.hasM === n.hasM && !!f(e.spatialReference, n.spatialReference) && t(e.paths, n.paths);
}

function i(e, n) {
  return e.hasZ === n.hasZ && e.hasM === n.hasM && !!f(e.spatialReference, n.spatialReference) && t(e.rings, n.rings);
}

function u(e, t) {
  return e.hasZ === t.hasZ && e.hasM === t.hasM && !!f(e.spatialReference, t.spatialReference) && n(e.points, t.points);
}

function s(e, n) {
  return e.hasZ === n.hasZ && e.hasM === n.hasM && !!f(e.spatialReference, n.spatialReference) && e.xmin === n.xmin && e.ymin === n.ymin && e.zmin === n.zmin && e.xmax === n.xmax && e.ymax === n.ymax && e.zmax === n.zmax;
}

function f(e, n) {
  return e === n || e && n && e.equals(n);
}

function l(n, t) {
  if (n === t) return !0;
  if (e(n) || e(t)) return !1;
  if (n.type !== t.type) return !1;

  switch (n.type) {
    case "point":
      return r(n, t);

    case "extent":
      return s(n, t);

    case "polyline":
      return a(n, t);

    case "polygon":
      return i(n, t);

    case "multipoint":
      return u(n, t);

    case "mesh":
      return !1;

    default:
      return;
  }
}

function c(e, n) {
  if (e === n) return !0;
  if (!e || !n) return !1;
  var t = Object.keys(e),
      r = Object.keys(n);
  if (t.length !== r.length) return !1;

  for (var _i = 0, _t2 = t; _i < _t2.length; _i++) {
    var _a2 = _t2[_i];
    if (e[_a2] !== n[_a2]) return !1;
  }

  return !0;
}

function o(e, n) {
  return e === n || null != e && null != n && e.objectId === n.objectId && !!l(e.geometry, n.geometry) && !!c(e.attributes, n.attributes);
}

export { o as equals, r as pointEquals };